import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AcmicService, AlertService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { CompanyTypeService } from '@services/_iam/company-type.service';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-bn-paynow-modal',
  templateUrl: './bn-paynow-modal.component.html',
  styleUrls: ['./bn-paynow-modal.component.scss']
})
export class BnPaynowModalComponent implements OnInit {
  @Input() policy: any;
  payNowModal: ModalOptions;
  isAcmic: boolean;
  hideModalOnRoute: boolean;
  isNativeApp: boolean;

  constructor(
    private acmicService: AcmicService,
    private alertService: AlertService,
    private paymentService: PaymentServiceService,
    private companyTypeService: CompanyTypeService,
    private router: Router
  ) {
    this.isAcmic = this.acmicService.isACMIC();
    this.hideModalOnRoute = false;
  }

  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }
  getPayBillSource(policy){
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).source
  }
  onCreatePaymentForm(accountID, zipCode, minAmount, format, company) {
    const minAmountDueonPolicy = Number(minAmount).toFixed(2);
    let xmlResp;
    if (company.companyName == 'TW') {
      xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else if (company.companyName == 'ACIC') {
      if (company.companyId == '25')
        xmlResp = company.companyId + 'B2C'
      else
        xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else {
      xmlResp = `<MiscellaneousData><UserId>${accountID}</UserId><ZipCode>${zipCode}</ZipCode><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    }
    return xmlResp;
  }
  getPayBillLink(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).url
  }
  getCheckDigits(policyNumber, checkDigits, company, zipCode, format) {
    if (company === 'TW') {
      return policyNumber + ';' + zipCode;
    } else if (company === 'ACIC') {
      return format.suffix + ';' + format.number
    } else {
      return policyNumber + checkDigits;
    }
  }
  onPayByCardBilling(policyNumber, zipCode, minAmount) {
    this.paymentService.setPaymentData(policyNumber, zipCode, minAmount);
    this.hideModalOnRoute = true;
    if (policyNumber.length === 10) {
      this.paymentService.redirectToPaymentExpress(
        this.isNativeApp,
        this.isAcmic
      );
    } else {
      this.paymentService.redirectToPayBill(policyNumber, zipCode, minAmount);
    }
  }
  preloadPaymentUsToken(policyNumber: string) {
    if (policyNumber.length === 10) {
      this.paymentService.preloadAndSaveToken(policyNumber);
    }
  }
  hideModal() {
    this.hideModalOnRoute = false;
  }

  resetHideModal() {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }
  showToast() {
    this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
    window.scroll(0, 0);
  }
  payNow() {
    this.router.navigate(['billing-new', this.policy?.policynumber?.policyNumber, 'make-a-payment']);
  }
  
  setPaynowModalOptions() {
    this.payNowModal = new ModalOptions({
      additionalButtonClasses: 'basic primary bn-paynow-action-btn',
      additionalClasses:
        'pay-now-modal modal-medium modal-dialog center-on-page modal-dialog-scrollable',
      buttonCopy: 'PAY_NOW',
      modalId: 'payNow',
      modalTranslateCopy: `${this.isAcmic ? 'MODAL_MAKE_A_PAYMENT' : ''}`,
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'my-insurence_payNow',
    });
  }
  ngOnInit(): void {
    this.isNative();
    this.setPaynowModalOptions();
  }

}